import React from "react";
import styles from "./customRadio.module.scss";

const CustomRadio = ({ name, label, value, onChange, checked }) => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <label htmlFor={`checkbox-${label}`}>{label}</label>
        <input
        name={name}
          id={`checkbox-${label}`}
          type="radio"
          value={value}
          onChange={() => onChange(value)}
          checked={checked}
        />
      </div>
    </div>
  );
};

export default CustomRadio;
